import React, { useState } from "react";
import { Lock } from "lucide-react";
import { Panel, Eyebrow, MonoLabel } from "@/components/Panel";
import { api, errText, TOKEN_KEY } from "@/lib/devadminApi";

export function DevAdminLogin({ onSuccess }) {
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      const { data } = await api.post("/auth/login", { phone, password });
      localStorage.setItem(TOKEN_KEY, data.token);
      onSuccess(data.user);
    } catch (ex) { setErr(errText(ex)); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <Panel className="p-8 w-full max-w-md" data-testid="devadmin-login-panel">
        <div className="flex justify-center mb-5" data-testid="devadmin-login-logo-wrap">
          <img src="/risse-bni-dark.webp" alt="RISSE BNI 26 · Davanagere Members Day" className="h-28 w-auto" data-testid="devadmin-login-logo" />
        </div>
        <Eyebrow>Devadmin · Restricted</Eyebrow>
        <h1 className="h-hero mt-3 text-3xl sm:text-4xl">Sign in to the wiring room.</h1>
        <form onSubmit={submit} className="mt-8 space-y-5">
          <div>
            <MonoLabel>Phone number</MonoLabel>
            <input data-testid="devadmin-login-phone" className="input-x mt-2 !font-mono" placeholder="10-digit mobile" value={phone} maxLength={10}
              onChange={(e) => setPhone(e.target.value.replace(/\D/g, ""))} autoFocus />
          </div>
          <div>
            <MonoLabel>Password</MonoLabel>
            <input data-testid="devadmin-login-password" type="password" className="input-x mt-2" value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          {err && <div data-testid="devadmin-login-error" className="text-sm" style={{ color: "var(--red-2)" }}>{err}</div>}
          <button data-testid="devadmin-login-submit" type="submit" disabled={busy} className="btn-red w-full justify-center">
            <Lock size={14} /> {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </Panel>
    </div>
  );
}
